import { unOrderedListToArray } from "@/lib/helpers";
import { load } from "cheerio";
import { useMemo } from "react";

type UseServiceContentProps =
  | {
      heading?: string;
      subHeading?: string;
      description: string;
      image?: string;
      hasHtmlDescription: true;
    }
  | {
      hasHtmlDescription: false;
      list: {
        heading?: string;
        subHeading?: string;
        description: string;
        image?: string;
      }[];
    };

type ServiceContentsReturnType = {
  heading: string;
  subHeading: string;
  description?: string;
  image?: string;
  list: string[];
};

const useServiceContent = (
  content: UseServiceContentProps,
  asRow: boolean = false
): ServiceContentsReturnType => {
  const serviceContents = useMemo<ServiceContentsReturnType>(() => {
    if (!content) {
      return {
        heading: "",
        subHeading: "",
        image: "",
        list: [],
      };
    }

    if (content.hasHtmlDescription) {
      const $ = load(content.description);
      return {
        heading: content.heading ?? "",
        subHeading: content.subHeading ?? "",
        image: content.image ?? "",
        description: asRow
          ? content.description
          : $("ul").length === 0
            ? content.description
            : undefined,
        list: unOrderedListToArray(content.description),
      };
    } else {
      const firstItem = (content?.list?.length && content.list[0]) || {
        heading: "",
        subHeading: "",
        image: "",
      };
      return {
        heading: firstItem?.heading ?? "",
        subHeading: firstItem.subHeading ?? "",
        image: firstItem.image ?? "",
        list: content?.list?.map((item) => item.description),
      };
    }
  }, [content, asRow]);

  return serviceContents;
};

export default useServiceContent;
